import { useState, type FormEvent } from 'react'
import s from './Find.module.css'

type Mode = 'id' | 'pw'

/** 아이디 찾기와 비밀번호 찾기는 입력만 다르고 흐름이 같아 한 페이지에서 탭으로 나눈다. */
const TABS: { key: Mode; label: string; lead: string }[] = [
  {
    key: 'id',
    label: '아이디 찾기',
    lead: '가입할 때 등록한 성명과 이메일을 입력하면 아이디를 이메일로 보내드립니다.',
  },
  {
    key: 'pw',
    label: '비밀번호 찾기',
    lead: '아이디와 가입 이메일을 입력하면 비밀번호 재설정 링크를 보내드립니다.',
  },
]

export default function Find() {
  // 해시에 #/find/pw로 들어오면 비밀번호 탭부터
  const [mode, setMode] = useState<Mode>(window.location.hash.endsWith('/pw') ? 'pw' : 'id')
  const [form, setForm] = useState<Record<string, string>>({})
  const [sent, setSent] = useState(false)

  const tab = TABS.find((t) => t.key === mode)!
  const first = mode === 'id' ? 'manager' : 'userId'
  const canSubmit = !!form[first]?.trim() && !!form.email?.trim()

  const set = (k: string, v: string) => setForm((f) => ({ ...f, [k]: v }))

  const switchTo = (m: Mode) => {
    setMode(m)
    setSent(false)
    setForm({})
  }

  // ponytail: 목업이라 발송은 콘솔까지만. 메일 발송 API 붙으면 여기서 POST.
  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    console.log('find', mode, form)
    setSent(true)
  }

  return (
    <div className={s.page}>
      <main className={s.card}>
        <div className={s.brand}>
          <a className={s.name} href="#/">
            <img className={s.mark} src="/assets/logo-mark.png" alt="" />
            AI 오토팀
          </a>
        </div>

        <div className={s.tabs} role="tablist">
          {TABS.map((t) => (
            <button
              key={t.key}
              type="button"
              role="tab"
              aria-selected={mode === t.key}
              onClick={() => switchTo(t.key)}
            >
              {t.label}
            </button>
          ))}
        </div>

        {sent ? (
          /* 계정이 있든 없든 같은 문구를 보여준다 — 화면에서 가입 여부가 드러나면
             아이디를 넣어보며 계정 존재를 확인할 수 있다. */
          <div className={s.done}>
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <rect x="3" y="5" width="18" height="14" rx="3" />
              <path d="m4 7 8 5.5L20 7" />
            </svg>
            <h2>메일을 보냈습니다</h2>
            <p>
              <b>{form.email}</b> 으로
              <br />
              {mode === 'id' ? '아이디 안내 메일을' : '비밀번호 재설정 링크를'} 보냈습니다.
              <br />
              입력한 정보로 가입된 계정이 있을 때만 발송됩니다.
            </p>
            <button className={s.again} type="button" onClick={() => switchTo(mode)}>
              다시 입력하기
            </button>
          </div>
        ) : (
          <form onSubmit={onSubmit}>
            <p className={s.lead}>{tab.lead}</p>

            <label className={s.row}>
              <span className={s.lb}>{mode === 'id' ? '성명' : '아이디'}</span>
              <input
                maxLength={mode === 'id' ? 20 : 30}
                placeholder={mode === 'id' ? '성명을 입력하세요.' : '아이디를 입력하세요.'}
                required
                value={form[first] ?? ''}
                onChange={(e) => set(first, e.target.value)}
              />
            </label>

            <label className={s.row}>
              <span className={s.lb}>이메일</span>
              <input
                type="email"
                maxLength={100}
                placeholder="가입 시 등록한 이메일을 입력하세요."
                autoComplete="email"
                required
                value={form.email ?? ''}
                onChange={(e) => set('email', e.target.value)}
              />
            </label>

            <button className={s.btn} type="submit" disabled={!canSubmit}>
              메일 받기
            </button>
          </form>
        )}

        <p className={s.foot}>
          계정이 기억나셨나요?<a href="#/login">로그인</a>
        </p>
      </main>
    </div>
  )
}
